import { clients } from '@/lib/https';
import { API_BASES } from '@/constant/endpoint.constant';
import { AI_ENDPOINTS } from '@/modules/gpt-chats/constants/endpoint.constant';
import {
  ICreateModelPayload,
  IModelResponse,
  IModelListPayload,
  IModelListResponse,
  IModelInfo,
  IUpdateModelPayload,
  IValidateModelResponse,
  IProvider,
  ISeedModelInfo,
  ModelStatus,
} from '@/modules/gpt-chats/types/aimodel.service.type';

export class ModelService {
  createModel(payload: ICreateModelPayload): Promise<IModelResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.MODELS}/`, JSON.stringify(payload));
  }

  getModels(payload: IModelListPayload): Promise<IModelListResponse> {
    return clients.get(
      `${API_BASES.AI}${AI_ENDPOINTS.MODELS}/?provider=${payload.provider}&search=${payload.search ?? ''}&page=${payload.page}&page_size=${payload.page_size}`
    );
  }

  getAllModels(payload: IModelListPayload): Promise<IModelListResponse> {
    const params = new URLSearchParams();

    if (payload.provider) params.append('provider', payload.provider);
    if (payload.model_type) params.append('model_type', payload.model_type);
    if (payload.is_active !== undefined && payload.is_active !== null)
      params.append('is_active', String(payload.is_active));
    if (payload.search) params.append('search', payload.search);
    if (payload.page) params.append('page', String(payload.page));
    if (payload.page_size) params.append('page_size', String(payload.page_size));
    if (
      payload.status &&
      (payload.status == ModelStatus.VALID || payload.status == ModelStatus.INVALID)
    )
      params.append('status', payload.status);

    // params.append('project_key', project_key);

    const queryString = params.toString();
    const url = `${API_BASES.AI}${AI_ENDPOINTS.MODELS}/${queryString ? `?${queryString}` : ''}`;

    return clients.get(url);
  }

  getModelById(modelId: string): Promise<IModelInfo> {
    return clients.get(`${API_BASES.AI}${AI_ENDPOINTS.MODEL_BY_ID.replace(':id', modelId)}`);
  }

  updateModel(modelId: string, payload: IUpdateModelPayload): Promise<IModelResponse> {
    return clients.post(
      `${API_BASES.AI}${AI_ENDPOINTS.MODEL_BY_ID.replace(':id', modelId)}`,
      JSON.stringify(payload)
    );
  }

  deleteModel(modelId: string): Promise<IModelResponse> {
    return clients.delete(`${API_BASES.AI}${AI_ENDPOINTS.MODEL_BY_ID.replace(':id', modelId)}`);
  }

  validateModel(modelId: string): Promise<IValidateModelResponse> {
    return clients.post(
      `${API_BASES.AI}${AI_ENDPOINTS.MODEL_VALIDATE.replace(':id', modelId)}`,
      ''
    );
  }

  getSeedProviders(): Promise<IProvider[]> {
    return clients.get(`${API_BASES.AI}${AI_ENDPOINTS.MODEL_SEED_PROVIDERS}`);
  }

  getSeedModelsByProvider(provider: string): Promise<ISeedModelInfo[]> {
    return clients.get(
      `${API_BASES.AI}${AI_ENDPOINTS.MODEL_SEED_BY_PROVIDER.replace(':provider', provider)}`
    );
  }
}

export const modelService = new ModelService();
